import { GridColDef } from '@mui/x-data-grid';

export const SERIAL_NO_FIELD = '__sno';

const INTERNAL_FIELDS = new Set([
  '__check__',
  '__detail_panel_toggle__',
  '__reorder__',
  '__tree_data_group__',
]);

/** Drop duplicate serial columns and other internal DataGrid columns from column definitions */
export function sanitizeGridColumns(columns: readonly GridColDef[] = []): GridColDef[] {
  return columns.filter((col) => {
    if (!col.field) return false;
    if (col.field === SERIAL_NO_FIELD) return false;
    if (INTERNAL_FIELDS.has(col.field)) return false;
    if (col.field.startsWith('__')) return false;
    if (col.headerName === 'S.No' || col.headerName === 'S.No.') return false;
    return true;
  });
}

export function createSerialNoColumn(): GridColDef {
  return {
    field: SERIAL_NO_FIELD,
    headerName: 'S.No',
    // Wide enough for uppercase themed header "S.NO" (letter-spacing) without ellipsis
    width: 72,
    minWidth: 72,
    maxWidth: 88,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    disableReorder: true,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => {
      const { page, pageSize } = params.api.state.pagination.paginationModel;
      const index = params.api.getRowIndexRelativeToVisibleRows(params.id);
      if (index < 0) return '';
      return page * pageSize + index + 1;
    },
  };
}

/** Prepend a pagination-aware S.No column to grid columns */
export function withSerialNo(columns: readonly GridColDef[] = [], enabled = true): GridColDef[] {
  const cleaned = sanitizeGridColumns(columns);
  if (!enabled) return cleaned;
  return [createSerialNoColumn(), ...cleaned];
}

/** Row index for custom MUI Table components (1-based, pagination-aware) */
export function tableSerialNo(page: number, pageSize: number, index: number): number {
  return page * pageSize + index + 1;
}
